// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"71":"f7e55c51","884":"e571e8c9"}[chunkId] + ".css";
};